import { useEffect, useMemo } from "react";
import {
  useDataProcessingStore,
} from "@/stores/data-processing";
import { useDataflowStore } from "@/stores/dataflow";
import type { DataflowData } from "@/types/stores/dataflow";

export function useProcessedDataLoader(
  activeDataflowId: string | null,
  activeDataflow: DataflowData | undefined,
  hasInputTransformer: boolean
) {
  const { executeDataflow } = useDataProcessingStore();

  const inputTransformerId = useMemo(() => {
    const inputTransformer = activeDataflow?.flow_definition_json?.find(
      (t) => t.type === "user_file" || t.type === "data_input"
    );
    if (!inputTransformer) return null;
    if (inputTransformer.type === "user_file") {
      return (inputTransformer as any).file_id;
    }
    if (inputTransformer.type === "data_input") {
      return (inputTransformer as any).db_table_id;
    }
    return null;
  }, [activeDataflow?.flow_definition_json]);

  useEffect(() => {
    if (!activeDataflowId || !hasInputTransformer || !inputTransformerId)
      return;

    const { getProcessedData, loadProcessedDataFromStorage } =
      useDataProcessingStore.getState();
    const existingData = getProcessedData(activeDataflowId);

    if (!existingData && activeDataflowId) {
      loadProcessedDataFromStorage(activeDataflowId)
        .then((loadedData) => {
          if (!loadedData) {
            const dataflowData =
              useDataflowStore.getState().dataflows[activeDataflowId];
            if (dataflowData) {
              executeDataflow(activeDataflowId, dataflowData).catch(() => {});
            }
          }
        })
        .catch(() => {});
    }
  }, [
    activeDataflowId,
    executeDataflow,
    hasInputTransformer,
    inputTransformerId,
  ]);
}

